import React from 'react';
import { useTranslation } from 'react-i18next';
import classes from './Gallery.module.css';
import interior1 from '../../assets/images/gallery/interior-1.webp';
import interior2 from '../../assets/images/gallery/interior-2.webp';
import interior3 from '../../assets/images/gallery/interior-3.webp';
import interior4 from '../../assets/images/gallery/interior-4.webp';

/* Alle Aufnahmen sind Hochformat. Die Kacheln des Rasters sind es nicht,
   deshalb legt objectPosition je Bild fest, welcher Ausschnitt sichtbar
   bleibt: bei den Raeumen die Liegen, beim Portrait das Gesicht. */
const tiles = [
  {
    src: interior3,
    alt: 'Gallery.alt.room3',
    span: classes.wide2x2,
    focus: 'center 62%',
  },
  {
    src: interior2,
    alt: 'Gallery.alt.room2',
    span: classes.wide2x1,
    focus: 'center 66%',
  },
  {
    src: interior1,
    alt: 'Gallery.alt.welcome',
    span: '',
    focus: 'center 22%',
  },
  {
    src: interior4,
    alt: 'Gallery.alt.room4',
    span: '',
    focus: 'center 60%',
  },
];

const Gallery: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section id="gallery" className={classes.gallery}>
      <h2>{t('Gallery.title')}</h2>
      <div className={classes.bento}>
        {tiles.map((tile) => (
          <figure
            key={tile.src}
            className={`${classes.tile} ${tile.span}`.trim()}
          >
            <img
              src={tile.src}
              alt={t(tile.alt)}
              loading="lazy"
              style={{ objectPosition: tile.focus }}
            />
          </figure>
        ))}
      </div>
    </section>
  );
};

export default Gallery;
